/**
 * © 2025 ZOODONIX TECHNOLOGIES (OPC) PRIVATE LIMITED
 * All rights reserved.
 *
 * This software may not be copied, modified, distributed, or used
 * in any form without the express written permission of the copyright holder.
 *
 * Unauthorized use is strictly prohibited.
 */

import { CssBaseline } from '@mui/material';
import { useRoutes } from 'react-router-dom';
import { MatxTheme } from './components';
import { AuthProvider } from './contexts/JWTAuthContext';
import { SettingsProvider } from './contexts/SettingsContext';
import routes from './routes';
import '../fake-db';
import { Provider } from 'react-redux';
import store from '../Store';

const App = () => {
	const content = useRoutes(routes);

	return (
		<Provider store={store}>
			<SettingsProvider>
				<AuthProvider>
					<MatxTheme>
						<CssBaseline />
						{content}
					</MatxTheme>
				</AuthProvider>
			</SettingsProvider>
		</Provider>
	);
};

export default App;
